import {useQueryClient} from '@tanstack/react-query'

import {useRefraMutation} from '../useRefraMutation'

import {mutations} from '@refra/api/mutations'
import {logger} from '@refra/modules/common/utils'

export const useUpdateUserStorageValue = () => {
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.setUserStorageValue,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useUpdateUserStorageValue')
        .extras({errorDetails})
        .error('Error occurred while updating user storage value')
    },
    onSuccess: async (_, params) => {
      await queryClient.setQueryData(
        ['getUserStorageValue', {keyIdentifier: params.keyIdentifier}],
        params
      )
    }
  })
}
